export const IMAGES = {
  logo: "https://customer-assets-wrfwihn1.emergentagent.net/job_react-setup-guide-2/artifacts/0uddxrlx_logo.png",
  hero: "https://images.unsplash.com/photo-1605745341112-85968b19335b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxjYXJnbyUyMHNoaXAlMjBvY2VhbiUyMGNhcmdvfGVufDB8fHx8MTc4NDYyODIwM3ww&ixlib=rb-4.1.0&q=85",
  // Verified RED onions – photo-1618512496248-a07fe83aa8cb (shiny red onions bunch)
  onionsHero: "https://images.unsplash.com/photo-1618512496248-a07fe83aa8cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxmcmVzaCUyMHJlZCUyMG9uaW9ucyUyMGhhcnZlc3R8ZW58MHx8fHwxNzg0NjI4MjAyfDA&ixlib=rb-4.1.0&q=85",
  // Verified RED onions – photo-1620574387735-3624d75b2dbc (red onions in wooden bowl)
  onionBasket: "https://images.unsplash.com/photo-1620574387735-3624d75b2dbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxmcmVzaCUyMHJlZCUyMG9uaW9ucyUyMGhhcnZlc3R8ZW58MHx8fHwxNzg0NjI4MjAyfDA&ixlib=rb-4.1.0&q=85",
  onionsRedPile: "https://images.unsplash.com/photo-1618512496248-a07fe83aa8cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxmcmVzaCUyMHJlZCUyMG9uaW9ucyUyMGhhcnZlc3R8ZW58MHx8fHwxNzg0NjI4MjAyfDA&ixlib=rb-4.1.0&q=85&w=1400",
  onionsPacked: "https://images.unsplash.com/photo-1620574387735-3624d75b2dbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxmcmVzaCUyMHJlZCUyMG9uaW9ucyUyMGhhcnZlc3R8ZW58MHx8fHwxNzg0NjI4MjAyfDA&ixlib=rb-4.1.0&q=85&w=1400",
  truck: "https://images.pexels.com/photos/20862827/pexels-photo-20862827.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const PRODUCTS = [
  {
    id: "red",
    name: "Fresh Red Onions",
    desc: "Available in all sizes 25mm to 80mm+",
    image: IMAGES.onionsHero,
  },
  {
    id: "nashik",
    name: "Nashik Onions",
    desc: "Famous for strong pungency, long shelf life & rich color",
    image: IMAGES.onionBasket,
  },
  {
    id: "pune",
    name: "Pune Onions",
    desc: "Best quality onions with excellent shelf life",
    image: IMAGES.onionsRedPile,
  },
  {
    id: "packed",
    name: "Packed Onions",
    desc: "Available in 5kg, 10kg, 20kg, 25kg & 50kg bags",
    image: IMAGES.onionsPacked,
  },
];

export const CERTIFICATIONS = [
  { name: "APEDA Registered", short: "APEDA" },
  { name: "FSSAI Certified", short: "FSSAI" },
  { name: "ISO 22000 Certified", short: "ISO" },
  { name: "HACCP Certified", short: "HACCP" },
  { name: "IEC Certified", short: "IEC" },
  { name: "Phytosanitary Certificate", short: "PHYTO" },
];

export const MARKETS = [
  "Middle East", "USA", "Australia",
  "Southeast Asia", "Canada", "Africa",
  "Europe", "UK", "& Many More",
];
